import * as React from 'react';
import '../../design/components/boxedMessage.less';

export enum MessageTypes{
    Message = 'message',
    Error = 'error-message',
    Warning = 'warning-message',
    Success = 'success-message',
    Normal = 'normal-message'
}

interface IBoxedMessageProps {
    message: JSX.Element,
    messageTypes: MessageTypes,
}

const BoxedMessage: React.FC<IBoxedMessageProps> = ({message, messageTypes}) => {
    return (
        <div className={messageTypes}>
            {message}
        </div>
    )
}

export default BoxedMessage;
